import getFileExtension from "./getFileExtension";
import {withPreviewFiles} from "constants/withPreviewFiles";

function isNoPreviewFile(fileName: string): boolean {
    const extension = getFileExtension(fileName)?.toLowerCase();
    return !withPreviewFiles.includes(extension!);
}

export default isNoPreviewFile;